'use client';

import { Button } from "flowbite-react";
import { setFeaturedJob } from "./ServerActions";
import { useEffect, useState } from "react";
import StyledSpinner from "app/components/StyledSpinner";

export default function FeaturedButton({jobId, isFeatured} : {jobId: string, isFeatured :boolean}) {

    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        setIsLoading(false);
    }, [isFeatured]);

    return <Button
        size={'xs'}
        color={isFeatured? 'success' : 'gray'}
        onClick={() => {
            setIsLoading(true);
            void setFeaturedJob(jobId, !isFeatured);
        }}>
        {isLoading
            ? <StyledSpinner />
            : (isFeatured ? '⭐' : '☆ Not') + ' Featured (click to toggle)'}
    </Button>

}
